import { AgGridReact } from "@ag-grid-community/react";
import { usePrecisionReport } from "../../Hooks/Features/Reports/usePrecisionReport"
import { SkeletonDataTable } from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { Calendar } from "primereact/calendar";

const PrecisionReport = () => {

    const { PRColDef, PRRowData, TEColDef, TERowData, TEBottomRowData, loader, handleExcelDownload, precisionOpts, precisionFilterValues, setPrecisionFilterValues, handleMonthChange, isChanged, setIsChanged, getPrecisionReport } = usePrecisionReport();

    return (
        <div>
            <div className='header-filters d-flex justify-content-between'>
                <div className='row' style={{ width: "100%" }}>
                    <div className='col-2'>
                        <MultiSelect placeholder='Leads' value={precisionFilterValues?.lead} options={precisionOpts?.leads} onChange={(e) => { setPrecisionFilterValues((prev) => ({ ...prev, lead: e.value })); setIsChanged(true); }} optionLabel="user_display_name" filter filterInputAutoFocus onHide={() => { if (isChanged) { getPrecisionReport(); setIsChanged(false); } }}
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'lead', precisionFilterValues?.lead, () => setPrecisionFilterValues((prev) => ({ ...prev, lead: [] })), () => getPrecisionReport([]))} />
                    </div>
                    <div className='col-2'>
                        <MultiSelect placeholder='Users' value={precisionFilterValues?.user} optionLabel="user_display_name" options={precisionOpts?.users} onChange={(e) => { setPrecisionFilterValues((prev) => ({ ...prev, user: e.value })); setIsChanged(true); }} filter filterInputAutoFocus onHide={() => { if (isChanged) { getPrecisionReport(); setIsChanged(false); } }} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'user', precisionFilterValues?.user, () => setPrecisionFilterValues((prev) => ({ ...prev, user: [] })), () => getPrecisionReport(precisionFilterValues?.lead, []))} />
                    </div>
                    <div className='col-3 d-flex align-items-center gap-2 c-pointer'>
                        <FontAwesomeIcon icon="fa-solid fa-backward-step" onClick={() => handleMonthChange(-1)} />
                        <Calendar
                            style={{ width: "150px" }}
                            value={precisionFilterValues?.date}
                            onChange={(e) => { setPrecisionFilterValues((prev) => ({ ...prev, date: e.value })); getPrecisionReport() }}
                            dateFormat="mm/yy"
                            view='month'
                        />
                        <FontAwesomeIcon icon="fa-solid fa-forward-step" onClick={() => handleMonthChange(+1)} />
                    </div>
                </div>
                <div>
                    <button title="Download Excel" className="button btn-primary" onClick={() => handleExcelDownload()}><FontAwesomeIcon icon="fa-solid fa-download" /></button>
                </div>
            </div>
            <div className="precision-report-heading mt-2">Team Efforts</div>
            {loader ? <SkeletonDataTable numSkeletons={8} /> :
                <div className="ag-theme-alpine" style={{ height: "34vh" }}>
                    <AgGridReact columnDefs={TEColDef} rowData={TERowData} rowHeight={30} pinnedBottomRowData={TEBottomRowData} />
                </div>
            }

            <div className="precision-report-heading mt-4">Performance Ranking</div>
            {loader ? <SkeletonDataTable numSkeletons={8} /> :
                <div className="ag-theme-alpine" style={{ height: "34vh" }}>
                    <AgGridReact columnDefs={PRColDef} rowData={PRRowData} rowHeight={30} />
                </div>
            }
        </div>
    )
}

export default PrecisionReport;